import { ERouteHttpVerb } from "@devowl-wp/api";
const locationRestKeyValueMapPatch = {
    path: "/key-value-map/:name/:key",
    method: ERouteHttpVerb.PATCH
};
export { locationRestKeyValueMapPatch };
